import axios from 'axios'
import Config from '@/core/config'
import router from '@/router'

const config = {
  baseURL: Config.baseUrl,
  timeout: 5 * 10000 // 请求超时时间设置
}

// 创建请求实例
const _axios = axios.create(config)
_axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'

// 对axios的request配置
_axios.interceptors.request.use(async (config) => {
  return config
}, error => {
  return Promise.reject(error)
})

// 对axios的response配置
_axios.interceptors.response.use((res) => {
  if(res.data.token){
		sessionStorage.setItem('token',res.data.token);
	}
  // console.log(window.location.pathname)
  if(res.data.code===401 && sessionStorage.getItem('token')){
    res.data.msg='登录已失效，请重新登录'
    sessionStorage.removeItem('token')

    router.push({
      path:'login',
      query:{
        url:window.location.pathname
      }
    })
  }
  return res.data
}, err => {
  if (axios.isCancel(err)) {
    // 中断promise链接
    return new Promise(() => {})
  } else {
    // Toast('请求错误，请重新发起请求！')
    // 把错误继续向下传递
    return Promise.reject(err)
  }
})

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 * @param noSignList 不需要签名的参数集合
 * @param isCancel 是否触发取消
 */
export function post(url, data = {}, params = {}, noSignList = {}, isCancel = false) {
  return _axios({
    method: 'post',
    url,
    data,
    params,
    noSignList,
    isCancel
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * @param {string} url
 * @param {object} params
 * @param isCancel 是否触发取消
 */
export function get(url, params = {}, isCancel = false) {
  return _axios({
    method: 'get',
    url,
    params,
    isCancel
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export function put(url, data = {}, params = {}) {
  return _axios({
    method: 'put',
    url,
    params,
    data
  }).catch((err) => {
    console.log(err)
  })
}

/**
 * @param {string} url
 * @param {object} params
 */
export function _delete(url, params = {}) {
  return _axios({
    method: 'delete',
    url,
    params
  }).catch((err) => {
    console.log(err)
  })
}

export default _axios
